import React, { Component } from "react";
import {Card, Form, Button, Row, Col} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { FaEdit, FaCheck } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class FiltrosAtendimento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filtros_atendimento_padrao: [
                {id: null, slug: "acao_navegador", nome: "Ação Navegador",  ordem: 0, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "andamento", nome: "Andamento", ordem: 1, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "finalizados", nome: "Finalizados", ordem: 2, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "cancelados", nome: "Cancelados", ordem: 3, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "nome_paciente", nome: "Nome do Paciente", ordem: 0, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "cpf_paciente", nome: "CPF do Paciente", ordem: 1, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "nome_laboratorio", nome: "Nome do Laboratório", ordem: 2, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "programa", nome: "Programa", ordem: 3, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "etapa", nome: "Etapa", ordem: 4, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "status", nome: "Status", ordem: 5, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "atendente", nome: "Atendente", ordem: 6, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false}
            ],
            programa_id: this.props.programa_id,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarFiltrosAtendimentoPrograma();
    }

    salvarFiltroAtendimento = (filtro) => {
        const url = filtro.id ? `/programas/filtros-atendimentos/${filtro.id}/` : '/programas/filtros-atendimentos/';
        const metodo = filtro.id ? 'put' : 'post';

        const dadosFiltroAtendimento = {
            nome: filtro.nome,
            slug: filtro.slug,
            ordem: filtro.ordem,
            exibir_filtro: filtro.exibir_filtro,
            tipo: filtro.tipo,
            padrao: filtro.padrao,
            programa_id: this.state.programa_id
        };
    
        api({
            method: metodo,
            url: url,
            data: dadosFiltroAtendimento,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (filtro.id) ? 'Filtro de atendimento atualizado com sucesso' : 'Filtro de atendimento cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            this.carregarFiltrosAtendimentoPrograma();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o filtro de atendimento, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'slug') {
                        content += `<br>&bull; Slug: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    carregarFiltrosAtendimentoPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/filtros-atendimentos/?programa_id=${this.state.programa_id}`)
            .then(response => {
                const filtrosAtendimento = response.data;
                // Mapeia os filtros do padrão e atualiza os campos de acordo com o slug
                const updatedFiltrosAtendimento = this.state.filtros_atendimento_padrao.map(filtroPadrao => {
                    // Encontra o filtro que tem o mesmo slug no retorno da API
                    const filtroApi = filtrosAtendimento.find(filtro => filtro.slug === filtroPadrao.slug);
                    
                    if (filtroApi) {
                        // Atualiza os campos com os dados da API
                        return {
                            ...filtroPadrao, // mantém as propriedades existentes
                            id: filtroApi.id,
                            nome: filtroApi.nome,
                            ordem: filtroApi.ordem,
                            padrao: filtroApi.padrao,
                            exibir_filtro: filtroApi.exibir_filtro
                        };
                    }
                    // Se não encontrar, retorna o filtro padrão sem alteração
                    return filtroPadrao;
                });
                //console.log(updatedColunasAtendimento);
                // Atualiza o estado com as colunas modificadas
                this.setState({ filtros_atendimento_padrao: updatedFiltrosAtendimento });
            })
            .catch(error => {
                console.error('Erro ao carregar filtros de atendimento:', error);
                
                let erro_msg = 'Erro ao carregar filtros de atendimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    };

    salvarFiltroAtendimento = (filtro) => {
        const url = filtro.id ? `/programas/filtros-atendimentos/${filtro.id}/` : '/programas/filtros-atendimentos/';
        const metodo = filtro.id ? 'put' : 'post';

        const dadosFiltroAtendimento = {
            nome: filtro.nome,
            slug: filtro.slug,
            ordem: filtro.ordem,
            exibir_filtro: filtro.exibir_filtro,
            tipo: filtro.tipo,
            padrao: filtro.padrao,
            programa_id: this.state.programa_id
        };
    
        api({
            method: metodo,
            url: url,
            data: dadosFiltroAtendimento,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (filtro.id) ? 'Filtro de atendimento atualizado com sucesso' : 'Filtro de atendimento cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            this.carregarFiltrosAtendimentoPrograma();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o filtro de atendimento, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'slug') {
                        content += `<br>&bull; Slug: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    handleFiltroAtendimentoChange = (index, event, fieldName, bool) => {
        const filtros_atendimento_padrao = [...this.state.filtros_atendimento_padrao];
        console.log(index)
        if(fieldName === "show"){
            filtros_atendimento_padrao[index] = { ...filtros_atendimento_padrao[index], [fieldName]: !bool };
        } else if(fieldName === "exibir_filtro" || fieldName === "padrao"){
            filtros_atendimento_padrao[index] = { ...filtros_atendimento_padrao[index], [fieldName]: bool };    
        } else {
            const { name, value } = event.target;
            filtros_atendimento_padrao[index] = { ...filtros_atendimento_padrao[index], [name]: value };    
        }
        
        this.setState({ filtros_atendimento_padrao });
    };

    render() {
        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Form>
                            <h4>Filtros de Atendimento Rápido</h4>
                            {this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_rapido').map((filtro, index) => {
                                const filtroIndex = index;
                                return (
                                    <div key={filtroIndex} className="row-list">
                                        <Card className="cardDestaque">
                                            <Card.Body>      
                                                <h4> Filtro: {filtro.nome} - <span title="Clique para editar o filtro" style={{cursor: "pointer"}} onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}>Editar {filtro.id ? `(${filtro.id})` : ""}<FaEdit/> </span></h4> 
                                                <div style={{display: filtro.show ? "block" : "none"}}>
                                                    <Row>                                                
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Nome</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="nome"
                                                                    value={filtro.nome} 
                                                                    onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'nome')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Slug</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="slug"
                                                                    value={filtro.slug}
                                                                    disabled 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Ordem</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name="ordem"
                                                                    value={filtro.ordem} 
                                                                    onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'ordem')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Visualizar Filtro?</Form.Label>
                                                                <div>
                                                                    <Button 
                                                                        variant={filtro.exibir_filtro ? "success" : "outline-secondary"}
                                                                        onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', true)}>
                                                                        Sim
                                                                    </Button>
                                                                    {' '}
                                                                    <Button 
                                                                        variant={!filtro.exibir_filtro ? "danger" : "outline-secondary"}
                                                                        onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', false)}>
                                                                        Não
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Filtro Padrão?</Form.Label>
                                                                <div>
                                                                    <Button 
                                                                        variant={filtro.padrao ? "success" : "outline-secondary"}
                                                                        onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'padrao', true)}>
                                                                        Sim
                                                                    </Button>
                                                                    {' '}
                                                                    <Button 
                                                                        variant={!filtro.padrao ? "danger" : "outline-secondary"}
                                                                        onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'padrao', false)}>
                                                                        Não
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Button variant="error" className="btn-sm ms-2 btn btn-danger" onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}><FaCheck className="me-1" /> Cancelar</Button>&nbsp;&nbsp;
                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarFiltroAtendimento(filtro)}><FaCheck className="me-1" /> Salvar Filtro</Button>&nbsp;&nbsp;
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                )

                            })}
                        </Form> 
                    </Card.Body>           
                </Card>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Form>
                            <h4>Filtros de Atendimento Avançado</h4>
                            {this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado').map((filtro, index) => {
                                const filtroIndex = this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_rapido').length + index;
                                return (
                                    <div key={filtroIndex} className="row-list">
                                        <Card className="cardDestaque">
                                            <Card.Body>      
                                                <h4> Filtro: {filtro.nome} - <span title="Clique para editar o filtro" style={{cursor: "pointer"}} onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}>Editar {filtro.id ? `(${filtro.id})` : ""}<FaEdit/> </span></h4> 
                                                <div style={{display: filtro.show ? "block" : "none"}}>
                                                    <Row>                                                
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Nome</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="nome"
                                                                    value={filtro.nome} 
                                                                    onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'nome')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Slug</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="slug"
                                                                    value={filtro.slug}
                                                                    disabled 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Ordem</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name="ordem"
                                                                    value={filtro.ordem} 
                                                                    onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'ordem')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Visualizar Filtro?</Form.Label>
                                                                <div>
                                                                    <Button 
                                                                        variant={filtro.exibir_filtro ? "success" : "outline-secondary"}
                                                                        onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', true)}>
                                                                        Sim
                                                                    </Button>
                                                                    {' '}
                                                                    <Button 
                                                                        variant={!filtro.exibir_filtro ? "danger" : "outline-secondary"}
                                                                        onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', false)}>
                                                                        Não
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Button variant="error" className="btn-sm ms-2 btn btn-danger" onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}><FaCheck className="me-1" /> Cancelar</Button>&nbsp;&nbsp;
                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarFiltroAtendimento(filtro)}><FaCheck className="me-1" /> Salvar Filtro</Button>&nbsp;&nbsp;
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                )
                            })}
                        </Form> 
                    </Card.Body>                
                </Card>
            </>
        );
    }
}

export default FiltrosAtendimento;

